export default __webpack_public_path__ + "static/media/shareicontwiterprofile.e4a10f33.svg";